<div class="clone-existing-project-container">
  <app-dynamic-form
    [jsonSchema]="formSchema"
    [layout]="'horizontal'"
    [submitLabel]="'Create'"
    [resetLabel]="'Cancel'"
    [showActions]="false"
    (formChange)="onFormChange($event)"
    (formSubmit)="onFormSubmit($event)">
  </app-dynamic-form>

  <div class="form-row-horizontal hierarchy-search-row" *ngIf="showHierarchySearch">
    <label class="form-label col-label">Enable filter across hierarchy</label>
    <div class="col-input">
      <label class="hierarchy-search-check">
        <input type="checkbox" [(ngModel)]="hierarchySearchEnabled">
      </label>
    </div>
  </div>

  <div *ngIf="isSubmitting" class="loading-overlay">
    <div class="spinner"></div>
    <p>Cloning project...</p>
  </div>
</div>


